<template>
  <div class="mt-1">
    <v-card flat tile>
      <v-toolbar elevation="1">
        <v-toolbar-title>Shop</v-toolbar-title>

        <v-spacer></v-spacer>
        <download-csv
          class="btn btn-default"
          :data="[this.$store.state.shopify.shopInfos]"
          name="ShopInfos.csv"
        >
          <v-btn dark color="cleed_blue">
            <b>export .csv</b>
            <v-icon class="ma-2">mdi-tray-arrow-down</v-icon>
          </v-btn>
        </download-csv>
      </v-toolbar>
      <v-card-text class="pt-1 pb-0 px-0">
        <v-row no-gutters justify="center">
          <v-col
            cols="12"
            lg="4"
            md="5"
            sm="6"
            v-for="(data, index) in shopInfos"
            :key="index"
          >
            <v-list subheader v-for="(item, index) in data" :key="index">
              <v-list-item class="mx-6">
                <v-list-item-content>
                  <v-list-item-title>{{ item[0] }} :</v-list-item-title>

                  <v-list-item-subtitle> - {{ item[1] }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "shopify_Shop",
  data: () => ({}),
  computed: {
    shopInfos() {
      const data = Object.entries(this.$store.state.shopify.shopInfos);
      const half = Math.ceil(data.length / 2);

      const firstHalf = data.slice(0, half);
      const secondHalf = data.slice(-half);
      return [firstHalf, secondHalf];
    },
  },
  created() {},
  methods: {},
};
</script>
